module.exports = __webpack_public_path__ + "img/flipper.578fa182.jpg";